export const DETAILS = {
  name: "Kharthie R",
  logo: "assets/images/name.svg",
  profile_links: {
    email: {
      link: "https://www.google.com/gmail/",
      image: "assets/images/gmail.svg",
    },
    github: {
      link: "https://github.com/Kharthie",
      image: "assets/images/github.svg",
    },
    linkedin: {
      link: "https://www.linkedin.com/in/kharthie-ramakrishnan-914589220/",
      image: "assets/images/linkedin.svg",
    },
  },
  profile_image: "assets/images/profile_image.jpeg",
  about_me: {
    para1: "<Hello World>",
    para2:
      "This is Kharthie R. I am a MERN Stack Developer. I have my Bachelor's Degree in Electronics & Communication and Engineering from S.R.V Engineering College.",
    para3:
      "I am a skilled MERN Stack  Developer with 20+ Mini-Projects successfully Deployed. I have the potential of converting ideas into working products. I am also highly skilled in HTML, CSS, Javascript & React. I have special interests in the field of  Front-end technology, Development Languages, Database, Basic design ability, Server & Working with API.",
    para4:
      "I also read some Technical Articles during my free time on Internet. I am an active Open Source Contributor on GitHub .",
    para5: "</Hello World>",
  },
  education: {
    college: {
      name: "S.R.V Engineering College",
      course: "B.E - Electronics & communication  Engineering",
      grade: "8.5",
      timeline: "2017-2021",
      image: "assets/images/college.jpg",
    },
    higher_secondary_school: {
      name: "Sri Bharathidasan Matric Hr Sec School",
      course: "Bio - Maths",
      grade: "72.2",
      timeline: "2016-2017",
      image: "assets/images/high_sec_school.jpg",
    },
    secondary_school: {
      name: "Ashoka Sishu Vihar Matriculation School",
      grade: "9.3",
      timeline: "2014-2015",
      image: "assets/images/sec_school.jpeg",
    },
  },
  skills: [
    {
      image: "assets/images/html5.svg",
      name: "HTML",
    },
    {
      image: "assets/images/css3.svg",
      name: "CSS",
    },
    {
      image: "assets/images/javascript.svg",
      name: "JavaScript",
    },
    {
      image: "assets/images/Mongo.png",
      name: "Mongo-DB",
    },
    {
      image: "assets/images/express.png",
      name: "Express",
    },
    {
      image: "assets/images/react.svg",
      name: "React",
    },
    {
      image: "assets/images/nodejs.png",
      name: "Node Js",
    },

    {
      image: "assets/images/git.svg",
      name: "Git",
    },

    {
      image: "assets/images/blogging.jpg",
      name: " Blogging",
    },
  ],
  projects: [
    {
      id: 1,
      title: "AMAZON APP:",
      link: "https://bespoke-phoenix-23072e.netlify.app/",
      link1: "https://github.com/Kharthie/amazonfrontend",
      link2: "https://github.com/Kharthie/amazonbackend",
      image: "https://c.tenor.com/JDPHxCqgEd0AAAAC/amazon.gif",

      description: {
        para1:
          "The application is a clone of a Amazon E-commerce website , we can select Product and do all functionalities in Amazon website.",
        para2:
          "The application is made completely user-friendly and has an amazing user-experience .",
        para3: "USERNAME : username@gmail.com ",
        para4: "PASSWORD : password",
      },
    },
    {
      id: 2,
      title: "GMAIL APP:",
      link: "https://famous-pastelito-760eb0.netlify.app/",
      link1: "https://github.com/Kharthie/gmail-front",
      link2: "https://github.com/Kharthie/gmailclonebe",
      image:
        "https://cdn.dribbble.com/users/2113992/screenshots/14510264/gmail_animation.gif",

      description: {
        para1:
          "The application is a clone of a G-mail, we can  do all functionalities in Gmail.",
        para2:
          "The application is made completely user-friendly and has an amazing user-experience .",
        para3: "USERNAME : username@gmail.com ",
        para4: "PASSWORD : password",
      },
    },
    {
      id: 3,
      title: "MEMORIES - BLOG APP:",
      link: "https://gentle-raindrop-934e77.netlify.app/",
      link1: "https://github.com/Kharthie/memoriesfront",
      link2: "https://github.com/Kharthie/memoriesback",
      image:
        "https://ansarshome.files.wordpress.com/2021/09/d3464a4351fdf340ccb6bb37c281381a.gif",

      description: {
        para1:
          "The application is like a blogging site , we can post and do all functionalities in Blog website.",
        para2:
          "The application is made completely user-friendly and has an amazing user-experience .",
        para3: "USERNAME : username2@gmail.com",
        para4: "PASSWORD : password",
      },
    },
    {
      id: 4,
      title: "NOTES APP:",
      link: "https://remarkable-empanada-ff9885.netlify.app/",
      link1: "https://github.com/Kharthie/notefront",
      link2: "https://github.com/Kharthie/noteback",
      image:
        "https://www.zohowebstatic.com/sites/default/files/mail/zc-notes-img.gif",

      description: {
        para1:
          "The application is like a notepad or notes-app. Which can store a information.",
        para2:
          "The application is made completely user-friendly and has an amazing user-experience .",
        para3: "USERNAME : username1@gmail.com",
        para4: "PASSWORD : password",
      },
    },
  ],
  experiences: [
    {
      id: 1,
      company: "Fresher:",
      positions: [
        {
          id: 1,
          position: "MERN Stack Development;",
          description:
            "I am recently completed MERN Stack Development with over 6 months of experience in Javascript, Reactjs, Nodejs, Express.js, MongoDB, HTML, CSS,Bootstrap.",
          timeline: "2022 - Present,",
        },
        {
          id: 2,
          position: "Projects;",
          description:
            "Some full-fledge application and many mini projects are Successfully Deployed.",
          timeline: "2022 - Present,",
        },
      ],
    },
  ],
};
